import renderSessionWithoutGeolocation from './renderSessionWithoutGeolocation';

export default renderSessionWithoutGeolocation;
